import { AxiosError } from 'axios';
import { axiosInstance } from '../api/axios.instance';
import { API_CONFIG } from '../api/config';
import { 
  EstadosLicitacionesResponseSchema,
  type ActualizarEstadoRequest 
} from '../schemas/licitaciones/estados/api.schema';
import { useUsuarioStore } from '../store/usuarioStore';

export class EstadosService {
  static async obtenerEstados(): Promise<Record<string, number>> {
    try {
      const response = await axiosInstance.get(
        API_CONFIG.ENDPOINTS.LICITACIONES.ESTADOS_MP
      );
      const validatedData = EstadosLicitacionesResponseSchema.parse(response.data);
      return validatedData.data;
    } catch (error) {
      console.error('Error en obtenerEstados:', error);
      
      if (error instanceof AxiosError) {
        console.error('Detalles del error:', {
          status: error.response?.status,
          data: error.response?.data,
          headers: error.response?.headers
        });

        if (error.response?.status === 401) {
          throw new Error('No autorizado: Verifica que estés autenticado');
        }
        
        if (!error.response) {
          throw new Error('Error de red: No se pudo conectar con el servidor');
        }

        throw new Error(
          error.response.data?.detail || 
          error.response.data?.message || 
          error.message || 
          'Error al obtener los estados'
        );
      }
      
      throw new Error('Error desconocido al obtener los estados');
    }
  }

  static async obtenerEstadosInternos(): Promise<Record<string, number>> {
    try {
      const response = await axiosInstance.get(
        API_CONFIG.ENDPOINTS.LICITACIONES.ESTADOS
      );
      const validatedData = EstadosLicitacionesResponseSchema.parse(response.data);
      return validatedData.data;
    } catch (error) {
      console.error('Error en obtenerEstadosInternos:', error);
      
      if (error instanceof AxiosError) {
        console.error('Detalles del error:', {
          status: error.response?.status,
          data: error.response?.data,
          headers: error.response?.headers
        });

        if (error.response?.status === 401) {
          throw new Error('No autorizado: Verifica que estés autenticado');
        }
        
        if (!error.response) {
          throw new Error('Error de red: No se pudo conectar con el servidor');
        }

        throw new Error(
          error.response.data?.detail || 
          error.response.data?.message || 
          error.message || 
          'Error al obtener los estados internos'
        );
      }
      
      throw new Error('Error desconocido al obtener los estados internos');
    }
  }

  static async actualizarEstados(listado: ActualizarEstadoRequest['listado']): Promise<void> {
    try {
      const usuario = useUsuarioStore.getState().usuario;
      if (!usuario?.tematica?.id) {
        throw new Error('No se pudo obtener la temática del usuario. Por favor, inicia sesión nuevamente.');
      }

      const request: ActualizarEstadoRequest = {
        listado,
        tematica_id: usuario.tematica.id
      };

      await axiosInstance.post(
        API_CONFIG.ENDPOINTS.LICITACIONES.ACTUALIZAR_ESTADO,
        request
      );
    } catch (error) {
      console.error('Error en actualizarEstados:', error);
      
      if (error instanceof AxiosError) {
        console.error('Detalles del error:', {
          status: error.response?.status,
          data: error.response?.data,
          headers: error.response?.headers
        });

        if (error.response?.status === 401) {
          throw new Error('No autorizado: Verifica que estés autenticado');
        }
        
        if (!error.response) {
          throw new Error('Error de red: No se pudo conectar con el servidor');
        }

        throw new Error(
          error.response.data?.detail || 
          error.response.data?.message || 
          error.message || 
          'Error al actualizar los estados'
        );
      }
      
      throw new Error('Error desconocido al actualizar los estados');
    }
  }
} 